import { useMemo, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import NewTicket from "./NewTicket";
import TicketList from "./TicketList";
import UserService from "src/Services/API/user.service";

const TicketLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const currentUser = UserService.getCurrentUser();
  const isSuperAdmin = currentUser?.roles?.[0]?.name === "Super Admin";

  const isNewActive = useMemo(() => location.pathname.endsWith("/ticket/new"), [location.pathname]);
  const isListActive = isSuperAdmin || !isNewActive;

  useEffect(() => {
    if (isSuperAdmin && isNewActive) {
      navigate("/ticket", { replace: true });
    }
  }, [isSuperAdmin, isNewActive, navigate]);

  const baseButtonClasses =
    "rounded-full px-3 py-1 text-[12px] font-OpenSansRegular font-[600] transition-colors";
  const activeButtonClasses = "bg-blueColor text-white";
  const inactiveButtonClasses = "bg-transparent text-subTitleColor";
  const contentWrapperClasses = isListActive ? "w-full" : "w-full max-w-[760px]";

  return (
    <div className="w-full">
      {!isSuperAdmin && (
        <div className="flex items-center gap-3 mb-4">
          <button
            type="button"
            className={`${baseButtonClasses} ${isNewActive ? activeButtonClasses : inactiveButtonClasses}`}
            onClick={() => navigate("/ticket/new")}
          >
            New Ticket
          </button>
          <button
            type="button"
            className={`${baseButtonClasses} ${isListActive ? activeButtonClasses : inactiveButtonClasses}`}
            onClick={() => navigate("/ticket")}
          >
            My Tickets
          </button>
        </div>
      )}

      <div className="w-full flex justify-center">
        <div className={`${contentWrapperClasses} ${isListActive ? "" : "mx-auto"}`}>
          {isNewActive && !isSuperAdmin ? <NewTicket /> : <TicketList />}
        </div>
      </div>
    </div>
  );
};

export default TicketLayout;
